import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const EmploymentStatusIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(
  ({ size = 24, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 20 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M18.0199 3.07362H15.1611V2.49951C15.1611 1.12087 14.0441 0 12.6655 0H7.33451C5.95587 0 4.8389 1.12087 4.8389 2.49951V3.07362H1.97618C0.886546 3.07752 0 3.96016 0 5.0498V14.8174C0 15.9071 0.88264 16.7936 1.97618 16.7936H18.0238C19.1135 16.7936 19.9961 15.9071 20 14.8174V5.0498C19.9961 3.96016 19.1096 3.07752 18.0199 3.07362ZM13.5911 3.47979C13.5911 3.7024 13.4114 3.88596 13.1849 3.88596H6.81117C6.58856 3.88596 6.405 3.70631 6.405 3.47979V2.49951C6.405 1.98789 6.81898 1.57391 7.3306 1.57391H12.6616C13.1732 1.57391 13.5872 1.98789 13.5911 2.49951V3.47979Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)

EmploymentStatusIcon.displayName = 'EmploymentStatusIcon'
